import { bootstrapServerToken, useSnackbarStore } from '@certara/common-react-components';
import { apiClient } from './api-client';

export function initializeApp() {
  // Set default window values if not provided by server
  window.version = window.version || '1.0.0-dev';
  window.baseUrl = window.baseUrl || '/';
  window.companyName = window.companyName || 'Certara';
  window.idleTimeout =
    window.idleTimeout || parseInt(import.meta.env.VITE_IDLE_TIMEOUT || '900000', 10);

  // Initialize the unified token refresh service from backend-injected globals.
  // Auth-specific bootstrap is handled by common-react-components — apps just
  // wire in their HTTP client and snackbar surface.
  bootstrapServerToken({
    http: apiClient,
    onRefreshFailed: (error, context) => {
      useSnackbarStore
        .getState()
        .addSnackbar(
          context === 'scheduled'
            ? 'Scheduled token refresh failed.'
            : 'Failed to refresh token.',
          'error',
          error instanceof Error ? error.message : String(error),
          true,
        );
    },
  });

  if (!window.oktaToken && import.meta.env.PROD) {
    console.warn(
      '❌ No authentication token found.\n' +
      'This app requires authentication. Please ensure you accessed it through the authenticated .NET endpoint.',
    );
  }
}
